import { COMPONENT_TYPES } from '../../../constants';
import CustomMembershipSignupComponent from './CustomMembershipSignup.component';
import CustomMembershipSignupEditor from './CustomMembershipSignup.editor';
import CustomMembershipSignupProperties from './CustomMembershipSignup.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { CustomMembershipSignupSkinnable } from './CustomMembershipSignupSkinnable';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(CustomMembershipSignupSkinnable);

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.CUSTOM_MEMBERSHIP_SIGNUP, // CUSTOM_MEMBERSHIP_SIGNUP으로 변경
  component: CustomMembershipSignupComponent,
  editorComponent: CustomMembershipSignupEditor,
  properties: CustomMembershipSignupProperties,
  defaultProps: {
    componentProps: {
      // 기본 속성 정의
      title: '자유 멤버십 가입',
      description: '직접 금액을 입력해 가입/추가 결제할 수 있습니다.',
      buttonText: '가입/추가 결제',
      completedText: '추가 결제가 완료되었습니다.',
      showRefundVisualization: true,
      refundLimitPercent: 400,
      minAmount: 10000,
      allowRejoin: true,
      assetOptions: [],
      skin: 'basic',
      askAmount: true,
      askQuantity: true,
      askAdditionalProducts: false,
      maxAmount: 100000000,
      minQuantity: 1,
      maxQuantity: 100
    },
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    }
  },
  category: 'membership', // 컴포넌트 카테고리
  icon: '💳', // 대표 아이콘
  name: '자유 멤버십 가입', // 표시할 이름
  skinnable: CustomMembershipSignupSkinnable // 스킨 가능 컴포넌트 연결
});

// 컴포넌트 및 타입 내보내기
export { default as CustomMembershipSignupComponent } from './CustomMembershipSignup.component';
export { default as CustomMembershipSignupEditor } from './CustomMembershipSignup.editor';
export { default as CustomMembershipSignupProperties } from './CustomMembershipSignup.properties';

// 타입 정의 내보내기 (isolatedModules 대응)
export type { 
  CustomMembershipSignupProps,
  CustomMembershipSignupEditorProps,
  AssetOption,
  AssetBalance
} from './CustomMembershipSignup.types'; 